import Chart from "./Chart";
import CONFIG from "../../../config";
export const config = {
  name: "percentBarChart",
  archive: "图表",
  domain: "柱状图",
  alias: "百分比堆叠柱图",
  thumb: CONFIG.ASSET_BASE_URL + "/charts/stackBarChart.png",
};
export const option = () => ({
  dataset: {
    source: [
      ["系列", "系列1", "系列2"],
      ["名称1", 43.3, 85.8],
      ["名称2", 83.1, 73.4],
      ["名称3", 86.4, 65.2],
      ["名称4", 72.4, 53.9],
    ],
  },
  title: {
    text: "百分比堆叠柱状图",
  },
  tooltip: {
    show: true,
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
    formatter: function (params) {
      console.log(params);
      var relVal = params[0].name;
      var value = 0;
      try {
        for (var i = 0, l = params.length; i < l; i++) {
          var encode = params[i].encode;
          var y = encode.y[0];
          value += params[i].value[y];
        }
        for (var i = 0, l = params.length; i < l; i++) {
          var encode = params[i].encode;
          var y = encode.y[0];
          relVal +=
            "<br/>" +
            params[i].seriesName +
            " : " +
            (
              (100 * parseFloat(params[i].value[y])) /
              parseFloat(value)
            ).toFixed(2) +
            "%";
        }
      } catch (e) {}
      return relVal;
    },
  },

  xAxis: {
    type: "category",
  },
  yAxis: {
    type: "value",
  },
  label: {
    show: false,
  },
  series: [
    {
      type: "bar",
      stack: "总和",
    },
    {
      type: "bar",
      stack: "总和",
    },
  ],
});
export default (props) => {
  return <Chart defaultOption={option()} {...props} />;
};
